export default __webpack_public_path__ + "static/media/bg-territory.a0ce24d4.jpg";